import { jsxs as l, jsx as C } from "react/jsx-runtime";
function t(r) {
  return /* @__PURE__ */ l("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M12.0088 17.2461H12C11.4473 17.2461 11.0039 17.6939 11.0039 18.2461C11.0039 18.7983 11.456 19.2461 12.0088 19.2461C12.5616 19.2461 13.0088 18.7983 13.0088 18.2461C13.0088 17.6939 12.5615 17.2461 12.0088 17.2461Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M21.6758 8.51509C19.0293 6.08979 15.5928 4.75389 12 4.75389C11.0146 4.75389 10.0435 4.86359 9.0947 5.05959L10.8432 6.80809C11.226 6.77229 11.6119 6.75389 11.9999 6.75389C15.0907 6.75389 18.0478 7.90279 20.3241 9.98969C20.5165 10.1655 20.7587 10.2524 20.9999 10.2524C21.2704 10.2524 21.5399 10.143 21.7372 9.92819C22.1102 9.52099 22.083 8.88819 21.6758 8.51509Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M18.8027 12.8633C19.1679 12.4492 19.1279 11.8169 18.7138 11.4522C17.1132 10.0409 15.1157 9.18059 13.0063 8.97119L16.0163 11.9811C16.503 12.2566 16.9663 12.5773 17.3915 12.9521C17.8065 13.3173 18.4385 13.2789 18.8027 12.8633Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M5.707 4.293C5.3164 3.9024 4.6836 3.9024 4.2929 4.293C3.9022 4.6836 3.9023 5.3164 4.2929 5.7071L5.1189 6.5331C4.1215 7.0794 3.1779 7.7327 2.3241 8.5152C1.9169 8.8882 1.8895 9.5211 2.2626 9.9283C2.6356 10.335 3.2675 10.3634 3.6757 9.9898C4.5578 9.1812 5.5507 8.5331 6.6059 8.02L8.2493 9.6635C7.1764 10.0893 6.1671 10.6758 5.286 11.4517C4.8719 11.8169 4.8319 12.4488 5.1971 12.8633C5.3944 13.0874 5.6698 13.2022 5.9471 13.2022C6.1825 13.2022 6.4178 13.1202 6.6082 12.9527C7.5367 12.1348 8.6307 11.5463 9.8045 11.2188L11.6939 13.1082C10.4454 13.1731 9.2341 13.6121 8.2566 14.3937C7.8259 14.7384 7.7556 15.3678 8.1004 15.799C8.2986 16.0461 8.5887 16.1745 8.8826 16.1745C9.1014 16.1745 9.3221 16.1027 9.5066 15.9553C10.9226 14.8205 13.0349 14.8113 14.4627 15.9314C14.4961 15.9576 14.5362 15.9648 14.5716 15.9861L18.2928 19.7072C18.4881 19.9025 18.744 20.0002 18.9998 20.0002C19.2556 20.0002 19.5115 19.9025 19.7068 19.7072C20.0974 19.3166 20.0974 18.6838 19.7068 18.2931L5.707 4.293Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  t as default
};
